/**
 * Default: layout > Emergency
 */

import {
	lockBodyScrolling,
	unlockBodyScrolling
} from '@ifabnpm/bootstrap/utils/scroll.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import Nav from '@ifabnpm/bootstrap/component/nav.js';
import Drawer from '@ifabnpm/bootstrap/component/drawer.js';
import drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageEmergency = SelectorEngine.findOne('#page-emergency-drawer');

let mainNavInstance;

/**
 * Drawer (Emergencysoverlay)
 */
const setupDrawer = () => {
	const trigger = SelectorEngine.findOne('[aria-controls="page-emergency-drawer"]');
	const closeBtn = SelectorEngine.findOne('[data-drawer-close]', pageEmergency);
	const drawer  = new Drawer(pageEmergency, {
		closeButton: false,
		onShow   : function() {
			Manipulator.addClass(trigger, '-active');
		},
		onHidden : () => {
			Manipulator.removeClass(trigger, '-active');
		}
	});

	EventHandler.on(trigger, 'click.ifab.pageEmergencyDrawer', (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.delegateTarget.classList.contains('-active')) {
			drawer.hide();
		} else {
			drawer.show();
		}
	});

	if(closeBtn) {
		EventHandler.on(closeBtn, 'click.ifab.pageEmergencyDrawer', () => {
			drawer.hide();
		});
	}
};

// -------
// Public
// -------

const emergency = () => {
	if (pageEmergency) {
		setupDrawer();
	}
};

// Export
export default emergency;
